import { createContext } from "react";
import { toast } from "react-toastify";
import { apiGet } from "../apiClients/base";
import { FeatureFlags } from "../utils/featureFlags";

// Load the feature flag data from the backend, once while creating the
// FeatureFlagsContext.
export const fetchFeatureFlagData = async (): Promise<FeatureFlags> => {
  try {
    const response = await apiGet<FeatureFlags>("/api/feature-flags/");

    return response.data;
  } catch (error) {
    toast.error("Error communicating with the Nephrolytics backend:" + error);
    return {};
  }
};

// Create the context with the feature flags data
export const FeatureFlagsContext = createContext<FeatureFlags | null>(null);
